import { useTranslation } from "react-i18next";
import Section2 from "./section-2";
import Section3 from "./section-3";
import Section5 from "./section-5";
import Section7 from "./section-7";
import Partners from "./partners";
import AIListing from "./AI-listing";
import Section4 from "./section-4";
import Footer from "./footer";
import { Helmet } from "react-helmet-async";
import Blogs from "./blogs";
import { Clock, TrendingUp, Users } from "lucide-react";
import { Dialog, DialogContent } from "@mui/material";
import FormFreeDemo from "../Real Estate Agencies/FormFreeDemo";
import { useState } from "react";
import Pricing from "../Pricing/Pricing";

const Home: React.FunctionComponent<{}> = (props) => {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogContent>
          <div className="card-started">
            <div className="row">
              <div className="col-md-12">
                <FormFreeDemo />
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <Helmet>
        <title>{t("Coralytics")}</title>
        <meta name="description" content={t("Over 80 AI capabilities")} />
      </Helmet>

      {/* section 1 */}
      <section
        className="relative min-h-screen flex items-center justify-center overflow-hidden "
        style={{ paddingTop: "20px" }}
      >
        {/* Background Gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50"></div>

        {/* Animated Background Elements */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-purple-200/30 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-pink-200/30 rounded-full blur-3xl animate-pulse delay-1000"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* Left Column - Content */}
            <div className="text-center lg:text-left">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-gray-900 leading-tight mb-6">
                From Listing to{" "}
                <span className="bg-gradient-to-r from-purple-600 to-pink-500 bg-clip-text text-transparent">
                  Closing
                </span>{" "}
                in Half the Time
              </h1>

              <p className="text-xl lg:text-2xl text-gray-600 mb-8 leading-relaxed">
                Stop managing technology. Start building relationships. Coraly
                handles the busywork so you can focus on deals.
              </p>

              {/* Benefits */}
              <div className="flex flex-col sm:flex-row gap-6 mb-10 justify-center lg:justify-start">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                    <Clock className="w-4 h-4 text-green-600" />
                  </div>
                  <span className="text-gray-700 font-medium">
                    Reclaim 20+ hours every week
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                    <TrendingUp className="w-4 h-4 text-blue-600" />
                  </div>
                  <span className="text-gray-700 font-medium">
                    Win 3x more instructions
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
                    <Users className="w-4 h-4 text-purple-600" />
                  </div>
                  <span className="text-gray-700 font-medium">
                    Close deals faster than ever
                  </span>
                </div>
              </div>

              {/* Social Proof */}
              <div className="mb-8">
                <p className="text-gray-600 font-medium">
                  Used by agents worldwide
                </p>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-centre">
                <button
                  className="bg-gradient-to-r from-purple-600 to-pink-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:shadow-xl transform hover:scale-105 transition-all duration-200"
                  onClick={handleClickOpen}
                >
                  See Your First Listing Transform
                </button>
              </div>

              {/* Disclaimer */}
              <div className="mt-8 text-xs text-gray-500 max-w-lg">
                *Results based on user reports and may vary depending on market
                conditions, property type, and individual usage. Past
                performance does not guarantee future results.
              </div>
            </div>

            {/* Right Column - Visual */}
            <div className="relative">
              <div className="relative bg-white rounded-2xl shadow-2xl p-8 transform rotate-3 hover:rotate-0 transition-transform duration-500">
                <img
                  src="/ChatGPT Image Jun 9, 2025, 12_34_38 PM.png"
                  alt="Before and after: Stressed agent vs successful agent closing deals"
                  className="w-full h-64 lg:h-80 object-cover rounded-xl"
                />
                <div className="absolute -bottom-4 -right-4 bg-gradient-to-r from-purple-600 to-pink-500 text-white p-4 rounded-xl shadow-lg">
                  <div className="text-2xl font-bold">23hrs</div>
                  <div className="text-sm opacity-90">saved/week*</div>
                </div>
              </div>

              {/* Floating Elements */}
              <div className="absolute -top-6 -left-6 bg-white rounded-xl shadow-lg p-4 animate-bounce">
                <div className="text-green-600 font-bold text-lg">Faster</div>
                <div className="text-sm text-gray-600">Closings*</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Real estate agents and agencies rely on Coralytics*/}
      <Section2 />

      <Partners />

      {/* AI Listing Creation */}
      <AIListing />

      <Section4 />

      {/*Generate & Enhance*/}
      <Section3 />

      {/* Understand & Moderate */}
      <Section5 />

      {/* Pricing */}
      <Pricing />

      {/* Coralytics is for */}
      <div className="cards-01 marg-2rem bg-green">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="h2-heading"> {t("Coralytics is for")}</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 mb-3">
              <div className="card">
                <div className="card-body">
                  <img
                    className="quotes"
                    src="/assets/images/image-1.webp"
                    alt="alternative"
                  />
                  <div className="testimonial-author">
                    {" "}
                    {t("Real Estate Agencies")}{" "}
                  </div>
                  <p className="testimonial-text">
                    {" "}
                    {t("Improve your listing quality")}{" "}
                  </p>
                  <div className="card-learn d-flex justify-content-center">
                    <a className="learn_more" href="/Real-Estate-Agencies">
                      {t("Learn More")}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="card">
                <div className="card-body">
                  <img
                    className="quotes"
                    src="/assets/images/image-2.webp"
                    alt="alternative"
                  />
                  <div className="testimonial-author">
                    {" "}
                    {t("Marketplaces")}{" "}
                  </div>
                  <p className="testimonial-text">
                    {" "}
                    {t("Automate more than 90% of your content")}{" "}
                  </p>
                  <div className="card-learn d-flex justify-content-center">
                    <a className="learn_more" href="/Marketplace">
                      {t("Learn More")}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="card">
                <div className="card-body flex-grow-1">
                  <img
                    className="quotes"
                    src="/assets/images/image-3.webp"
                    alt="alternative"
                  />
                  <div className="testimonial-author">
                    {" "}
                    {t("Real Estate Developers")}{" "}
                  </div>
                  <p className="testimonial-text">
                    {" "}
                    {t("Protect your brand and increase")}{" "}
                  </p>
                  <div className="card-learn d-flex justify-content-center">
                    <a className="learn_more" href="/Developers">
                      {t("Learn More")}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="card">
                <div className="card-body">
                  <img
                    className="quotes"
                    src="/assets/images/image-4.webp"
                    alt="alternative"
                  />
                  <div className="testimonial-author">
                    {" "}
                    {t("Interior Designers")}{" "}
                  </div>
                  <p className="testimonial-text">
                    {" "}
                    {t("Improve quality and compliance standards")}{" "}
                  </p>
                  <div className="card-learn d-flex justify-content-center">
                    <a className="learn_more" href="/Interior-Designers">
                      {t("Learn More")}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*Blogs*/}
      <Blogs />

      {/*Boost your return on marketing */}
      <Section7 />

      <Footer />
    </>
  );
};
export default Home;
